<div class="label-canvas__container">
  <canvas #canvas id="labelCanvas" width="100%" height="100%"></canvas>
</div>